import { IKeyValue } from "Components/Generic/KeyValueGrid/IKeyValue";
import { Value } from "Components/Generic/KeyValueGrid/Value";
import { isTrue } from "Utils/Boolean";
import { getItemById } from "Utils/Item";
import { useCallback, useMemo } from "react";
import { isFunction } from "Utils/Function";
import { AV_ORIGIN_COLUMN_LIST, AV_RESULT_COLUMN_LIST } from "../../AddressValidation/AddressValidationColumns";
import { DialogType } from "../../Dialog/DialogType";
import { DC_ORIGIN_COLUMN_LIST, DC_RESULT_COLUMN_LIST } from "../../DuplicateCheck/DuplicateCheckColums";
import { IChoiceProps } from "./IChoiceProps";
import { IUseChoice } from "./IUseChoice";

export function useChoice(props: IChoiceProps): IUseChoice {
  const {
    cache, onAction, onIsRelevant, result, selectedResultItemId, type
  } = props;
  const cachedProjectItem = useMemo(() => getItemById(cache, result?.[`@id`]), [cache, result]);

  const hasIsRelevantIcon = isTrue(result?.[`@isOrigin`]) && isFunction(onIsRelevant);
  const onIsRelevantClick = useCallback(() => {
    if (!isFunction(onIsRelevant)) {
      return;
    }
    onIsRelevant(result?.[`@id`]);
  }, [onIsRelevant, result]);

  const hasAction = isFunction(onAction);
  const onActionClick = useCallback(() => {
    if (!isFunction(onAction)) {
      return;
    }
    onAction(result);
  }, [onAction, result]);

  const isSelectedResult = result?.[`@resultId`] === selectedResultItemId;

  const items = useMemo(
    () => getColumnsByType(type, isTrue(result?.[`@isOrigin`])).map<IKeyValue>((column) => ({
      key: column,
      value: <Value fieldName={column} item={result} placeholder="-" />
    })),
    [result, type]
  );

  return {
    cachedProjectItem,
    items,
    hasAction,
    hasIsRelevantIcon,
    isSelectedResult,
    onActionClick,
    onIsRelevantClick
  };
}

function getColumnsByType(type: DialogType, isOrigin: boolean): string[] {
  if (isOrigin) {
    return type === DialogType.AddressValidation ? AV_ORIGIN_COLUMN_LIST : DC_ORIGIN_COLUMN_LIST;
  }

  return type === DialogType.AddressValidation ? AV_RESULT_COLUMN_LIST : DC_RESULT_COLUMN_LIST;
}
